import { ICrossCourseCorequisitesDatasource } from '../datasources/cross_course_corequisite_datasource';
import { CrossCourseLinkedSectionsModel } from '../models/cross_course_linked_sections_model';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import { ITermCoursesDatasource } from '../../../views/term_courses/datasources/term_courses_datasource';

export type GetCrossCourseLinkedSectionsCommand = (sectionId: number, includeStatus: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getCrossCourseLinkedSectionsCommand',
    (
      $http: ng.IHttpService,
      ngCrossCourseLinkedSectionsModel: CrossCourseLinkedSectionsModel,
      defineCommandORM: IDefineCommand,
      ngSectionsDatasource: ISectionsDatasource,
      ngCrossCourseCorequisitesDatasource: ICrossCourseCorequisitesDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource
    ): ICommand => {
      return defineCommandORM(
        'getCrossCourseLinkedSectionsCommand',
        (deferred: ng.IDeferred<IQuery[]>, sectionId: number, includeStatus: boolean) => {
          $http
            .get(`/reg/linked_section_coreq/section/${sectionId}/${includeStatus ? '?populate_satisfaction=true' : ''}`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              _4.each(data, (course) => {
                const existingCourse = ngTermCoursesDatasource.get(course.id);
                if (existingCourse) {
                  ngTermCoursesDatasource.write([_4.merge(existingCourse, course)]);
                } else {
                  ngTermCoursesDatasource.write(data);
                }
              });

              ngCrossCourseCorequisitesDatasource.write([
                {
                  id: sectionId,
                  course_corequisites: data
                }
              ]);

              ngCrossCourseLinkedSectionsModel.clear().write({
                coreqs: data,
                coreqs_of_section: sectionId
              });
              const sections = _4.reduce(
                _4.map(data, (item: any) => item.sections),
                (sum: any, n: any) => sum.concat(n)
              );
              _4.each(sections, (section: any) => {
                const exists = ngSectionsDatasource.get(section.id);
                if (!exists) {
                  ngSectionsDatasource.write([section]);
                }
              });
              deferred.resolve();
            })
            .catch(deferred.reject);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_corequisite/commands/get_cross_course_linked_sections_command.ts